import React from 'react';
import styled, { css } from 'styled-components';
import type { FlattenSimpleInterpolation } from 'styled-components';
import { label16 } from '@engage/typography';

export const ClassLabelSection: React.FC<
  React.PropsWithChildren<{
    margin?: string;
    label?: FlattenSimpleInterpolation;
    labelStyles: FlattenSimpleInterpolation;
    children: React.ReactNode;
  }>
> = ({ margin = '', label = css``, labelStyles, children }) => {
  return (
    <ClassLabelContainer
      margin={margin}
      label={label}
      labelStyles={labelStyles}
      data-test-id="videoCellClassLabel"
    >
      {children}
    </ClassLabelContainer>
  );
};

const ClassLabelContainer = styled.div<{
  margin?: string;
  label?: FlattenSimpleInterpolation;
  labelStyles: FlattenSimpleInterpolation;
}>`
  ${p => p.labelStyles}
  ${props => (props.label ? props.label : label16)}
  margin: ${props => (props.margin ? props.margin : '')};
`;
